
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1103Grid extends Serenity.EntityGrid<Report_1103Row, any> {
        myGridDropdownButton: Common.Helpers.GridDropdownButton;
        protected getColumnsKey() { return Report_1103Columns.columnsKey; }
        protected getDialogType() { return Report_1103Dialog; }
        protected getIdProperty() { return Report_1103Row.idProperty; }
        protected getInsertPermission() { return Report_1103Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1103Row.localTextPrefix; }
        protected getService() { return Report_1103Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            let combineButtons: GeniuzPOS.Common.Helpers.GridDropdownButtonItem[] = [
                {
                    key: "SellUnitPrice1",
                    title: "1",
                    isDefault: true,
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice1')
                },
                {
                    key: "SellUnitPrice2",
                    title: "2",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice2')
                },
                {
                    key: "SellUnitPrice3",
                    title: "3",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice3')
                },
                {
                    key: "SellUnitPrice4",
                    title: "4",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice4')
                },
                {
                    key: "SellUnitPrice5",
                    title: "5",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice5')
                },
                {
                    key: "SellUnitPrice6",
                    title: "6",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice6')
                },
            ];

            this.myGridDropdownButton = new GeniuzPOS.Common.Helpers.GridDropdownButton(this.toolbar.element.find(".buttons-outer"), combineButtons, {
                title: "ราคาขาย",
                cssClass: "price-selection-button",
            })

            this.showOnlyPriceColumn('SellUnitPrice1')
        }

        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            var el = grid.element.find('.price-selection-button');
            var selectedKey = $(el).attr('data-selected-key');
            if (selectedKey) {
                var chk = selectedKey.substring(0, selectedKey.length - 1);
                gridColumns = gridColumns.filter(c => !c.field.startsWith(chk) || c.field === selectedKey)
                let n = columns.find(n => {
                    return options.columnStyles[n]['field'].startsWith(chk)
                });
                descriptions.push(`ราคาขายที่ : ${options.columnStyles[n]['title']}-${selectedKey.replace(chk, '')}`)
            }

            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();
                console.log(quickFilters)
                let filters = Object.keys(request.EqualityFilter);
                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    if (filterValue) {
                        if (quickFilter.options.lookupKey) {
                            let lookup = Q.getLookup(quickFilter.options.lookupKey);
                            filterValue = lookup.itemById[filterValue][lookup.textField];
                        } else if (quickFilter.options.enumKey) {
                            let enumKey = quickFilter.options.enumKey;
                            let enumValue = Q.toId(filterValue);
                            filterValue = Serenity.EnumFormatter.format(Serenity.EnumTypeRegistry.get(enumKey), enumValue);
                        }
                    } else {
                        filterValue = "ไม่ระบุ";
                    }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {
                        descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                    }
                }
            }

            return [descriptions, gridColumns];
        }

        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            // need to register this plugin for grouping or you'll have errors
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1103Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            let reportTitle = 'รายงานราคาขายเทียบราคาทุน (Selling price & Cost report)'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "PluCode", title: "รหัสสินค้าขาย", cellWidth: 20 },
                1: { field: "PluDesc", title: "ชื่อสินค้า", cellWidth: 40 },
                2: { field: "SellUnit", title: "หน่วย", cellWidth: 10 },
                3: { field: "SellUnitPrice1", title: "ราคาขาย", cellWidth: 15, halign: 'right' },
                4: { field: "SellUnitPrice2", title: "ราคาขาย", cellWidth: 15, halign: 'right' },
                5: { field: "SellUnitPrice3", title: "ราคาขาย", cellWidth: 15, halign: 'right' },
                6: { field: "SellUnitPrice4", title: "ราคาขาย", cellWidth: 15, halign: 'right' },
                7: { field: "SellUnitPrice5", title: "ราคาขาย", cellWidth: 15, halign: 'right' },
                8: { field: "SellUnitPrice6", title: "ราคาขาย", cellWidth: 15, halign: 'right' },
                9: { field: "VatType", title: "V?", cellWidth: 10 },
                10: { field: "VatCode", title: "V.Code", cellWidth: 10 },
                //11: { field: "SaledisVate",title: "ราคาขาย(หัก VAT)",cellWidth: 15},
                //12: { field: "Purunitplu",title: "ราคาทุนมาตรฐาน",cellWidth: 15},
                //13: { field: "Lastunitplu",title: "ราคาทุนล่าสุด",cellWidth: 15},
                //14: { field: "EvPurunitplu",title: "ราคาทุนเฉลี่ย",cellWidth: 15},
                11: { field: "SupplName", title: "ผู้จำหน่าย", cellWidth: 25 },
                12: { field: "CatName", title: "หมวดสินค้า", cellWidth: 25 },
                13: { field: "SubCat1Name", title: "หมวดสินค้า-2", cellWidth: 25, isHidden: true },
                14: { field: "SubCat2Name", title: "หมวดสินค้า-3", cellWidth: 25, isHidden: true },
                15: { field: "BrandName", title: "ยี่ห้อ", cellWidth: 20, isHidden: true },
                // 16: { field: "StyleName", title: "รุ่น/แบบ", cellWidth: 15, isHidden: true },
                // 17: { field: "SizeName", title: "ขนาด", cellWidth: 15, isHidden: true },
                // 18: { field: "ColorName", title: "สี", cellWidth: 15, isHidden: true },
                // 18: { field: "TasteName", title: "กลิ่น/รส", cellWidth: 15, isHidden: true},
                // 19: { field: "MatTypeName", title: "วัสดุที่ใช้ผลิต", cellWidth: 15, isHidden: true},
            }

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     //separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            // //Buttons Group By Category
            // buttons.push({
            //     title: 'Group by:หมวดสินค้า',
            //     cssClass: 'expand-all-button',
            //     separator: true,
            //     onClick: () => this.view.setGrouping(
            //         [{
            //             formatter: x => 'หมวดสินค้า: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'CatName',
            //         }])
            // });

            // //Buttons Group By Category and Supplie
            // buttons.push({
            //     title: 'ผู้จำหน่าย',
            //     cssClass: 'expand-all-button',
            //     onClick: () => this.view.setGrouping(
            //         [{
            //             formatter: x => 'ผู้จำหน่าย: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'SupplName'
            //         }])
            // });

            // buttons.push({
            //     title: ' ผู้จำหน่าย > หมวดสินค้า',
            //     cssClass: 'expand-all-button',
            //     onClick: () => this.view.setGrouping(
            //         [{
            //             formatter: x => 'ผู้จำหน่าย: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'SupplName'
            //         }, {                        
            //             formatter: x => 'หมวดสินค้า: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'CatName'
            //         }])
            // });

            // buttons.push({
            //     title: ' หมวดสินค้า > ผู้จำหน่าย',
            //     cssClass: 'expand-all-button',
            //     onClick: () => this.view.setGrouping(
            //         [{
            //             formatter: x => 'หมวดสินค้า: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'CatName'
            //         }, {                        
                        
            //             formatter: x => 'ผู้จำหน่าย: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'SupplName'
            //         }])
            // });

            // buttons.push({
            //     title: 'No Grouping',
            //     cssClass: 'collapse-all-button',
            //     onClick: () => this.view.setGrouping([])
            // });

            return buttons;
        }


        private showOnlyPriceColumn(selectedColumn: string) {
            var columns = this.getColumns();
            var chk = selectedColumn.substring(0, selectedColumn.length - 1);
            let columns2 = columns.filter(c => !c.field.startsWith(chk) || c.field === selectedColumn)
        }
    }
}